<template>
  <v-row no-gutters>
    <v-col cols="12" md="12">
      <div class="mt-8">
        Have your event attendees to promote your event ahead of time and
        post-event on social media.
      </div>
    </v-col>
    <v-col cols="6">
      <v-form ref="eventPromotionForm" v-model="isValid">
        <v-row dense>
          <v-col cols="12" md="12" class="mt-8">
            <div class="text-subtitle-1 font-weight-bold">
              Social Media to promote on
            </div>
            <div>
              Select a social media platform you prefer your attendees to post
              on
            </div>
          </v-col>
          <v-col cols="12" md="12">
            <v-autocomplete
              v-model="currentEvent.socialMediaPlatform"
              :items="socialMediaPlatforms"
              outlined
              dense
              :rules="requiredRules"
              item-text="title"
              item-value="title"
              :allow-overflow="false"
            >
              <template v-slot:item="{ item }">
                <div class="d-inline-flex justify-start align-center">
                  <img
                    :src="require(`@/assets/icons/${item.logo}`)"
                    style="width: 20px"
                  />

                  <v-list-item-content class="ml-2">
                    <v-list-item-title class="font-weight-regular">{{
                      item.title
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      class="font-weight-regular text-wrap"
                      v-html="item.subtitle"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </div>
              </template>
              <template v-slot:selection="{ item }">
                <div class="d-flex justify-start">
                  <img
                    :src="require(`@/assets/icons/${item.logo}`)"
                    style="width: 20px"
                  />
                  <div class="ml-2">{{ item.title }}</div>
                </div>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="12">
            <div class="text-subtitle-1 font-weight-bold">
              {{ captionAndImageTitle }}
            </div>
            <div>{{ captionAndImageSubtitle }}</div>
          </v-col>
          <!---Start: Pre event post caption and image-->
          <v-col cols="12" md="12" class="mb-5">
            <div class="px-6 py-6 rounded-lg" style="background-color: #f6f7fc">
              <v-row dense>
                <v-col cols="12">
                  <v-switch
                    class="
                      mt-0
                      mb-3
                      text-body-2
                      font-weight-medium
                      mc-checkbox
                      d-inline
                    "
                    hide-details
                    v-model="currentEvent.hasPreEventSocialMediaPost"
                    label="Pre-event"
                    style="font-size: 14px !important"
                  ></v-switch>
                  <div class="mt-2">
                    Insert caption and image to to be shared prior to your event
                    starting
                  </div>
                </v-col>
                <template v-if="currentEvent.hasPreEventSocialMediaPost">
                  <v-col
                    cols="12"
                    md="12"
                    v-if="currentEvent.socialMediaPlatform != 'Instagram'"
                  >
                    <div class="black--text mb-2">Caption</div>
                    <v-textarea
                      background-color="white"
                      auto-grow
                      v-model="currentEvent.captionBeforeEventStarts"
                      outlined
                      class="text-body-2 text-color-grey"
                      rows="10"
                      row-height="8"
                      :rules="requiredRules"
                      dense
                    ></v-textarea>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                    v-if="currentEvent.socialMediaPlatform != 'LinkedIn'"
                  >
                    <div class="black--text mb-2">Image</div>
                    <div
                      class="rounded-lg"
                      style="background-color: #f6f7fc; width: fit-content"
                    >
                      <AddNewImage
                        v-if="currentEvent.preEventPromoImageURL == ''"
                        :applyDashedBorder="true"
                        :isRectangle="true"
                        :width="imageWidth"
                        :height="imageHeight"
                        text="Upload an image"
                        @click="showUploadPromoImageDialog = true"
                        color="white"
                      />

                      <v-hover v-slot="{ hover }" v-else>
                        <v-sheet
                          :width="imageWidth"
                          :height="imageHeight"
                          class="rounded-lg"
                        >
                          <v-img
                            :width="imageWidth"
                            :height="imageHeight"
                            class="rounded-lg"
                            :src="currentEvent.preEventPromoImageURL"
                          >
                            <div class="text-right mt-2 mr-2" v-show="hover">
                              <AvatarButton
                                icon="mdi-image"
                                tooltipText="Change image"
                                @click="showUploadPromoImageDialog = true"
                                className="d-inline-block mr-2"
                              />

                              <AvatarButton
                                icon="mdi-trash-can"
                                tooltipText="Delete image"
                                @click="currentEvent.preEventPromoImageURL = ''"
                                className="d-inline-block"
                              />
                            </div>
                          </v-img>
                        </v-sheet>
                      </v-hover>
                    </div>

                    <p
                      v-if="
                        preEventPromoImageURLError &&
                        this.currentEvent.preEventPromoImageURL == ''
                      "
                      class="error--text"
                    >
                      Image is required
                    </p>

                    <UploadImageDialog
                      :show="showUploadPromoImageDialog"
                      isDisplayImage
                      :previewType="previewType"
                      ref="uploadCoverImageDialog"
                      @close="showUploadPromoImageDialog = false"
                      @uploaded="handlePromoImageUploaded"
                      :uploadToBusinessProfile="false"
                    />
                  </v-col>
                </template>
              </v-row>
            </div>
          </v-col>
          <!---End: Pre post caption and image-->

          <!---Start: Post event post caption and image-->
          <v-col cols="12" md="12">
            <div class="px-6 py-6 rounded-lg" style="background-color: #f6f7fc">
              <v-row dense>
                <v-col cols="12">
                  <v-switch
                    class="
                      mt-0
                      mb-3
                      text-body-2
                      font-weight-medium
                      mc-checkbox
                      d-inline
                    "
                    hide-details
                    v-model="currentEvent.hasPostEventSocialMediaPost"
                    label="Post-event"
                    style="font-size: 14px !important"
                  ></v-switch>
                  <div class="mt-2">
                    Insert caption and image to be shared after your event has
                    ended
                  </div>
                </v-col>
                <template v-if="currentEvent.hasPostEventSocialMediaPost">
                  <v-col
                    cols="12"
                    md="12"
                    v-if="currentEvent.socialMediaPlatform != 'Instagram'"
                  >
                    <div class="black--text mb-2">Caption</div>
                    <v-textarea
                      background-color="white"
                      auto-grow
                      v-model="currentEvent.captionAfterEventHasEnded"
                      outlined
                      class="text-body-2 text-color-grey"
                      rows="10"
                      row-height="8"
                      :rules="requiredRules"
                      dense
                    ></v-textarea>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                    v-if="currentEvent.socialMediaPlatform != 'LinkedIn'"
                  >
                    <div class="black--text mb-2">Image</div>
                    <div
                      class="rounded-lg"
                      style="background-color: #f6f7fc; width: fit-content"
                    >
                      <AddNewImage
                        v-if="currentEvent.postEventPromoImageURL == ''"
                        :applyDashedBorder="true"
                        :isRectangle="true"
                        :width="imageWidth"
                        :height="imageHeight"
                        text="Upload an image"
                        @click="showUploadPostEventPromoImageDialog = true"
                        color="white"
                      />

                      <v-hover v-slot="{ hover }" v-else>
                        <v-sheet
                          :width="imageWidth"
                          :height="imageHeight"
                          class="rounded-lg"
                        >
                          <v-img
                            :width="imageWidth"
                            :height="imageHeight"
                            class="rounded-lg"
                            :src="currentEvent.postEventPromoImageURL"
                          >
                            <div class="text-right mt-2 mr-2" v-show="hover">
                              <AvatarButton
                                icon="mdi-image"
                                tooltipText="Change image"
                                @click="
                                  showUploadPostEventPromoImageDialog = true
                                "
                                className="d-inline-block mr-2"
                              />

                              <AvatarButton
                                icon="mdi-trash-can"
                                tooltipText="Delete image"
                                @click="
                                  currentEvent.postEventPromoImageURL = ''
                                "
                                className="d-inline-block"
                              />
                            </div>
                          </v-img>
                        </v-sheet>
                      </v-hover>
                    </div>

                    <p
                      v-if="
                        postEventPromoImageURLError &&
                        this.currentEvent.postEventPromoImageURL == ''
                      "
                      class="error--text"
                    >
                      Image is required
                    </p>

                    <UploadImageDialog
                      :show="showUploadPostEventPromoImageDialog"
                      isDisplayImage
                      :previewType="previewType"
                      @close="showUploadPostEventPromoImageDialog = false"
                      @uploaded="handlePostEventPromoImageUploaded"
                      :uploadToBusinessProfile="false"
                    />
                  </v-col>
                </template>
              </v-row>
            </div>
          </v-col>
          <!---End: Post event post caption and image-->
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import UploadImageDialog from "@/components/UploadImageDialog";
import AddNewImage from "@/components/AddNewImage";
import AvatarButton from "@/components/AvatarButton";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showUploadPromoImageDialog: false,
      socialMediaPlatforms: [
        {
          id: 1,
          title: "Facebook",
          subtitle:
            "Enable your attendees to share your event as a post on their <br/> Facebook  newsfeed.",
          logo: "facebook-logo.svg",
        },
        {
          id: 2,
          title: "Instagram",
          subtitle:
            "Enable your attendees to share your event as an instagram story <br/> publicly or amongst their followers.",
          logo: "instagram-logo.svg",
        },
        {
          id: 1,
          title: "LinkedIn",
          subtitle:
            "Enable your attendees to share your event as a post on their  <br/> LinkedIn feed.",
          logo: "linkedin-logo.png",
        },
      ],
      // "Facebook", "Instagram", "LinkedIn"
      isValid: false,
      promoImageURLError: false,
      requiredRules: [(v) => !!v || "This is a required field"],
      showUploadPostEventPromoImageDialog: false,
      preEventPromoImageURLError: "",
      postEventPromoImageURLError: "",
    };
  },
  created() {
    //Get the default value for caption before event starts

    //Set default value for promotion platform
    // if (this.currentEvent.socialMediaPlatform == "")
    //   this.currentEvent.socialMediaPlatform = "Facebook";

    if (
      this.currentEvent.captionBeforeEventStarts == "" &&
      this.currentEvent.socialMediaPlatform == "Facebook"
    ) {
      this.getFacebookSocialHandle();
    }

    if (
      this.currentEvent.captionBeforeEventStarts == "" &&
      this.currentEvent.socialMediaPlatform == "Instagram"
    ) {
      this.getInstagramSocialHandle();
    }

    if (
      this.currentEvent.captionBeforeEventStarts == "" &&
      this.currentEvent.socialMediaPlatform == "LinkedIn"
    ) {
      this.getLinkedInSocialHandle();
    }

    //Set default value for social handle from business profile
    // if (this.currentEvent.socialHandle == "")
    //   this.getDefaultSocialHandleFromBusinessProfile();
  },
  computed: {
    ...mapGetters(["currentEvent", "businessProfile"]),
    previewType() {
      if (this.currentEvent.socialMediaPlatform == "Instagram")
        return "potrait";
      else return "rectangle";
    },
    imageWidth() {
      if (this.currentEvent.socialMediaPlatform == "Instagram") return 281.25;
      else return 567 / 1.2;
    },
    imageHeight() {
      if (this.currentEvent.socialMediaPlatform == "Instagram") return 500;
      else return 375 / 1.2;
    },
    platformInfo() {
      console.log(
        "this.currentEvent.socialMediaPlatform: ",
        this.currentEvent.socialMediaPlatform
      );
      if (this.currentEvent.socialMediaPlatform == "Facebook")
        return " Facebook recommends a minimum width of 320px for mobile and 479px for desktop.";
      else if (this.currentEvent.socialMediaPlatform == "Instagram")
        return " Instagram recommends an image size of 1,080 x 1,920 or images with an aspect ratio of either 9/16 or 9/18 for their stories.";
      else return "";
    },
    captionAndImageTitle() {
      if (this.currentEvent.socialMediaPlatform == "Facebook")
        return "Caption and Image";
      else if (this.currentEvent.socialMediaPlatform == "Instagram")
        return "Image";
      else return "Caption";
    },
    captionAndImageSubtitle() {
      if (this.currentEvent.socialMediaPlatform == "Facebook")
        return "Make it easy for your event attendees to share your event by including a caption and image. Include any URL or any information you would like to have in the caption.";
      else if (this.currentEvent.socialMediaPlatform == "Instagram")
        return "Make it easy for your event attendees to share your event by uploading a photo.";
      else
        return "Make it easy for your event attendees to share your event by including a caption. Include any URL or any information you would like to have in the caption.";
    },
  },
  components: {
    UploadImageDialog,
    AddNewImage,
    AvatarButton,
  },
  watch: {
    "currentEvent.socialHandle": function (newValue, oldValue) {
      this.updateSocialHandle(oldValue, newValue);
    },
    "currentEvent.socialMediaPlatform": function (newSocialMediaPlatform) {
      //Set default value for social handle from business profile
      this.currentEvent.preEventPromoImageURL = "";
      this.currentEvent.postEventPromoImageURL = "";
      this.getDefaultSocialHandleFromBusinessProfile();

      if (newSocialMediaPlatform == "Facebook") this.getFacebookSocialHandle();
      else if (newSocialMediaPlatform == "Instagram")
        this.getInstagramSocialHandle();
      else this.getLinkedInSocialHandle();
    },
  },
  methods: {
    handlePromoImageUploaded(downloadURL) {
      this.currentEvent.preEventPromoImageURL = downloadURL;
    },
    validate() {
      this.$refs.eventPromotionForm.validate();
      let isValid = this.$refs.eventPromotionForm.validate();
      if (
        this.currentEvent.hasPreEventSocialMediaPost &&
        this.currentEvent.socialMediaPlatform != "LinkedIn" &&
        this.currentEvent.preEventPromoImageURL == ""
      ) {
        this.preEventPromoImageURLError = true;
        isValid = false;
      }
      if (
        this.currentEvent.hasPostEventSocialMediaPost &&
        this.currentEvent.socialMediaPlatform != "LinkedIn" &&
        this.currentEvent.postEventPromoImageURL == ""
      ) {
        this.postEventPromoImageURLError = true;
        isValid = false;
      }
      return isValid;
    },

    updateSocialHandle(oldValue, newSocialHandle) {
      let oldSocialHandle = oldValue == "" ? "YourSocialHandle" : oldValue;

      this.currentEvent.captionBeforeEventStarts =
        this.currentEvent.captionBeforeEventStarts.replace(
          "@" + oldSocialHandle,
          "@" + newSocialHandle
        );

      this.currentEvent.captionWhileEventIsHappening =
        this.currentEvent.captionWhileEventIsHappening.replace(
          "@" + oldSocialHandle,
          "@" + newSocialHandle
        );

      this.currentEvent.captionAfterEventHasEnded =
        this.currentEvent.captionAfterEventHasEnded.replace(
          "@" + oldSocialHandle,
          "@" + newSocialHandle
        );
    },
    getDefaultSocialHandleFromBusinessProfile() {
      switch (this.currentEvent.socialMediaPlatform) {
        case "Facebook":
          this.currentEvent.socialHandle =
            this.businessProfile.facebookURL || "";
          break;
        case "LinkedIn":
          this.currentEvent.socialHandle =
            this.businessProfile.linkedinURL || "";
          break;
        case "Instagram":
          this.currentEvent.socialHandle =
            this.businessProfile.instagramURL || "";
          break;
        default:
          break;
      }
    },
    handlePostEventPromoImageUploaded(downloadURL) {
      this.currentEvent.postEventPromoImageURL = downloadURL;
    },
    getFacebookSocialHandle() {
      this.currentEvent.captionBeforeEventStarts = `The excitement for ${this.currentEvent.hostName}’s ${this.currentEvent.name} is building - can't wait! @pappyon.co ${this.currentEvent.eventPageURL}`;
      this.currentEvent.captionWhileEventIsHappening = `I’m pumped to be at ${this.currentEvent.hostName}’s ${this.currentEvent.name} right now, the vibe is great 🤩 @pappyon.co ${this.currentEvent.eventPageURL}`;
      this.currentEvent.captionAfterEventHasEnded = `Had such a great time at ${this.currentEvent.hostName}’s ${this.currentEvent.name} 😍 @pappyon.co ${this.currentEvent.eventPageURL}`;
    },
    getInstagramSocialHandle() {
      this.currentEvent.captionBeforeEventStarts = `The excitement for ${this.currentEvent.hostName}’s ${this.currentEvent.name} is building - can't wait! @pappyon.co ${this.currentEvent.eventPageURL}`;
      this.currentEvent.captionWhileEventIsHappening = `I’m pumped to be at ${this.currentEvent.hostName}’s ${this.currentEvent.name} right now, the vibe is great 🤩 @pappyon.co ${this.currentEvent.eventPageURL}`;
      this.currentEvent.captionAfterEventHasEnded = `Had such a great time at ${this.currentEvent.hostName}’s ${this.currentEvent.name} 😍 @pappyon.co ${this.currentEvent.eventPageURL}`;
    },
    getLinkedInSocialHandle() {
      this.currentEvent.captionBeforeEventStarts = `The excitement for ${this.currentEvent.hostName}’s ${this.currentEvent.name} is building - can't wait!`;
      this.currentEvent.captionWhileEventIsHappening = `I’m pumped to be at ${this.currentEvent.hostName}’s ${this.currentEvent.name} right now, the vibe is great 🤩`;
      this.currentEvent.captionAfterEventHasEnded = `Had such a great time at ${this.currentEvent.hostName}’s ${this.currentEvent.name} 😍`;
    },
  },
};
</script>

<style >
.text-color-grey textarea {
  color: #616161 !important;
}
</style>